import React from "react";
import { Chip } from "@mui/material";

const MS_IN_DAY = 1000 * 60 * 60 * 24;

const getFullDaysDiff = (dateString) => {
  if (!dateString) return null;

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return null;

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();

  if (diffMs < 0) return 0;

  return Math.floor(diffMs / MS_IN_DAY);
};

const DeliveredDate = ({ value }) => {
  if (!value) return null;

  const date = new Date(value);
  if (isNaN(date.getTime())) return null;

  const days = getFullDaysDiff(value);
  if (days === null) return null;

  const isWarning = days >= 3;

  return (
    <>
      {date.toLocaleString()}{" "}
      <Chip
        label={`${days} дн.`}
        size="small"
        variant={isWarning ? "filled" : "outlined"}
        color={isWarning ? "warning" : "default"}
      />
    </>
  );
};

export default DeliveredDate;
